export default __webpack_public_path__ + "static/media/PinkFrame02.7a869684.png";